/** new bundle js **/
$("input[name=bf-bundle]:radio").click(function (e) {
  var id = $(this).val();
  var price = $(this).attr("data-price");
  var pprice = $(this).attr("data-pprice");
  $(".cv__blackFriday-atc").attr("data-variant-id", id);
  $("#AddToCart--buybar").attr("data-variant-id", id);
  $(".cv__blackFriday-atc").attr("data-price", price);
  $(".cv__blackFriday-atc").attr("data-pprice", pprice);
  $('[name="pin-price"]').val(pprice).change();
  /*$('.cv__blackFriday-modal-price').each(function(){
    var value = $(this).data('id');
    if(value == id){
      $(this).removeClass('hide');
    }else{
      $(this).addClass('hide');
    }
  });*/
  $(this)
    .parents(".cv__blackFriday-bundle")
    .children(".cv__blackFriday-bundle-tabs")
    .each(function () {
      $(this).children(".cv__blackFriday-bundle-block").removeClass("active");
    });
  $(this).parents(".cv__blackFriday-bundle-block").addClass("active");
});

$(".cv__blackFriday-atc, #AddToCart--buybar").click(function (e) {
  e.preventDefault();
  var id = $(this).attr("data-variant-id");
  var price = $(".cv__blackFriday-atc").attr("data-price");
  $.ajax({
    type: "post",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      id: id,
      quantity: 1,
    },
    success: function (response) {},
  });
  $(".cv__blackFriday-modal").removeClass("hide");
  $("body").addClass("cv__bf-overlay");
});

$(".cv__blackFriday-modal-atcx, .cv__blackFriday-modal-closex").click(function (
  e
) {
  e.preventDefault();
  $(".cv__blackFriday-modal").addClass("hide");
  $("body").removeClass("cv__bf-overlay");

  // window.location.replace("/cart");
});

$(document).ready(function () {
  $(document).on("click", ".upsell-btn-active", function (e) {
    e.preventDefault();
    var product_id = $(this).attr("data-product-id");
    $(".overlay").show();
    $(".upsell-collection").flickity("destroy");
    $(this).parents(".carousel-cell").addClass("hidden");
    // var quantity_main = $('.product_section').find('input#quantity').val();
    $.ajax({
      type: "post",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        id: product_id,
        quantity: 1,
      },
      success: function () {
        $(".overlay").hide();
        $(".upsell-collection").flickity({
          // options
          cellAlign: "center",
          contain: true,
          pageDots: false,
        });
        show_cart();
        // window.location.replace("/cart");
      },
    });
  });
});

$(document).on('click', '.cv__blackFriday-modal-warranty-atc', function(e) { 

  console.log('hi');
  e.preventDefault();

  setTimeout(function () {
    var warranty_id = $(".cv__blackFriday-modal-price").attr("data-id");
    var quantity_main = $(".product_section").find("input#quantity").val();
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true })
    );
    $.ajax({
      type: "post",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        id: warranty_id,
        quantity: quantity_main,
      },
      success: function () {
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:loading:end", { bubbles: true })
        );

        //$(".cv__blackFriday-modal").addClass("hide");
       // $("body").removeClass("cv__bf-overlay");

        setTimeout(function () {
          $(".cv__blackFriday-modal-atc").trigger("click");
        }, 50);

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );

        // window.location.replace("/cart");
      },
    });
  }, 500);
});




function show_cart() {
  console.log("test");

  $.ajax({
    url: "/cart.js",
    dataType: "json",
    cache: false,
    success: function (cart) {
      refreshCart(cart);
      if ($("html").hasClass("remodal-is-locked")) {
        $(".remodal-close").click();
      }

      if ($("#header").is(":visible")) {
        $("#header .cart_container").addClass("active_link");
      } else if ($(".sticky_nav--stick").length) {
        $(".sticky_nav .cart_container").addClass("active_link");
      } else {
        $(".top_bar .cart_container").addClass("active_link");
      }

      $("body").addClass("blocked-scroll");
      //   $('.upsell-collection').slick('refresh');
      $(".offcanvas-backdrop").addClass("active");
      $(".cart_container").addClass("active_link");
    },
  });
}


$(function () {
  setTimeout(function () {
    $(".upsell-collection").flickity({
      // options
      cellAlign: "center",
      contain: true,
      pageDots: false,
      ImagesLoaded: true,
    });
  }, 200);
});

function resetUpsellProducts() {
  window.theme = window.theme || {};
  theme.routes = {
    home: "{{ routes.root_url }}",
    cart: "{{ routes.cart_url | append: '.js' }}",
    cartPage: "{{ routes.cart_url }}",
    cartAdd: "{{ routes.cart_add_url | append: '.js' }}",
    cartChange: "{{ routes.cart_change_url | append: '.js' }}",
    search: "{{ routes.search_url }}",
  };

  fetch(
    "".concat(theme.routes.home, "?").concat("timestamp=").concat(Date.now()),
    {
      credentials: "same-origin",
      method: "GET",
    }
  )
    .then((response) => response.text())
    .then((data) => {

      console.log('im here');
      const new_html1 = new DOMParser()
        .parseFromString(data, "text/html")
        .querySelector(".upsell-container").innerHTML;
      $(".upsell-container").html(new_html1);

      $(".upsell-collection").flickity({
        // options
        cellAlign: "center",
        contain: true,
        pageDots: false,
        ImagesLoaded: true,
      });

      $(".upsell-container").show();
    });
}

// sliders

$(document).ready(function () {
  var e = $(".text-with-carousel"),
    a = 1,
    n = 1,
    o = "20px",
    i = "40px",
    s =
      '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="21.243" height="37.483" viewBox="0 0 21.243 37.483"><path id="Path_4" data-name="Path 4" d="M0,0-14,14.988,0,29" transform="translate(17 4.24)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/></svg>',
    r =
      '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="21.243" height="37.483" viewBox="0 0 21.243 37.483"><path id="Path_4" data-name="Path 4" d="M0,0,14,14.988,0,29" transform="translate(4.243 4.24)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/></svg>';
  $(".instagram--carousel").slick({
    adaptiveHeight: !1,
    autoplay: 1,
    autoplaySpeed: 1200,
    arrows: true,
    centerMode: !0,
    centerPadding: "0",
    dots: !1,
    draggable: !0,
    infinite: !0,
    slidesToShow: n,
    slidesToScroll: a,
    touchThreshold: 4,
    prevArrow: '<button class="slick-prev">' + s + "</button>",
    nextArrow: '<button class="slick-next">' + r + "</button>",
    responsive: [
      {
        breakpoint: 500,
        settings: {
          autoplay: !0,
          centerMode: true,
          centerPadding: "60px",
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplaySpeed: 1800,
        },
      },
      {
        breakpoint: 361,
        settings: {
          autoplay: !0,
          centerMode: true,
          centerPadding: "60px",
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplaySpeed: 1800,
        },
      },
    ],
  });

  // if ($(window).width() > 768) {
  //   $(".webcast-slick").slick({
  //     centerMode: true,
  //     centerPadding: "200px",
  //     slidesToShow: 3,
  //     slidesToScroll: 1,
  //     arrows: true,

  //     prevArrow:
  //       '<div class="slick-prev"><span class="right icon-left-arrow"></span></div>',
  //     nextArrow:
  //       '<div class="slick-next"><span class="right icon-right-arrow"></span></div>',
  //     swipeToSlide: true,
  //     infinite: true,
  //     adaptiveHeight: true,
  //     autoplay: false,
  //     autoplaySpeed: 1800,
  //   });
  // }

  // if ($(window).width() < 768) {
  //   $(".webcast-slick").slick({
  //     centerMode: true,
  //     centerPadding: "50px",
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     arrows: true,

  //     prevArrow:
  //       '<div class="slick-prev"><span class="right icon-left-arrow"></span></div>',
  //     nextArrow:
  //       '<div class="slick-next"><span class="right icon-right-arrow"></span></div>',
  //     swipeToSlide: true,
  //     infinite: true,
  //     adaptiveHeight: true,
  //     autoplay: true,
  //     autoplaySpeed: 1800,
  //   });
  // }

   $(".webcast-slick").slick({
      centerMode: true,
      centerPadding: "200px",
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:
        '<div class="slick-prev"><span class="right icon-left-arrow"></span></div>',
      nextArrow:
        '<div class="slick-next"><span class="right icon-right-arrow"></span></div>',
      swipeToSlide: true,
      infinite: true,
      adaptiveHeight: true,
      autoplay: false,
      autoplaySpeed: 1800,
      centerMode: true,
      centerPadding: "200px",
      responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: "50px",
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 500,
        settings: {
          centerMode: true,
          centerPadding: "50px",
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
    });

    $("#peachperfect-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      prevArrow:
        '<div class="slick-prev"><span class="right icon-left-arrow"></span></div>',
      nextArrow:
        '<div class="slick-next"><span class="right icon-right-arrow"></span></div>',
      swipeToSlide: true,
      infinite: true,
      adaptiveHeight: true,
      autoplay: false,
      autoplaySpeed: 1800,
       responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: "30px",
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        },
      },
      {
        breakpoint: 500,
        settings: {
          centerMode: true,
          centerPadding: "30px",
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        },
      },
    ],
    });

  $(".logo-bar").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    swipeToSlide: true,
    infinite: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 1800,
    arrows: false,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".slider-nav").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: true,
    focusOnSelect: true,
  });

  $("a[data-slide]").click(function (e) {
    e.preventDefault();
    var slideno = $(this).data("slide");
    $(".slider-nav").slick("slickGoTo", slideno - 1);
  });

  $(".main-carousel").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    swipeToSlide: true,
    infinite: true,
    adaptiveHeight: true,
    autoplay: false,
    autoplaySpeed: 1800,
    arrows: false,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

window.onresize = function (event) {
 // resetUpsellProducts();

   // $('.text-with-carousel').slick('setPosition');
   // $('.logo-bar').slick('setPosition');
   // $('.slider-nav').slick('setPosition');
   // $('.main-carousel').slick('setPosition');
  
};


$(".video_modal_close_custom").click(function (e) {
  var video = document.getElementById("myVideo");
  setTimeout(function () {
    $('video-media').trigger('click');
  }, 200);
  video.pause();
  $('video-media').removeAttr('playing');
  $(this).parent().find('.video_modal_close').trigger('click');
  video.currentTime = 0;  
});


$(".popup").click(function (e) {
  console.log('popup open');
  var video = document.getElementById("myVideo"); 
  setTimeout(function () {
    $('video-media').trigger('click');
  }, 200);
 
});
